export const register = "/signup";
export const designation = "/designation/fetchAllDesignation";
export const department = "/department/getAll"; //get
export const Employeee = "/employees/getAll"; //all user
export const Add_Employe = "/basic/saveemployee";
export const User = "/basic/fetchdata";
export const post_Employement = "/employment/saveEmployment";
export const getAllEmp = "/employment/getAllEmp";
export const delete_emp = "/employment/delete";
export const Post_department = "/department/saveDepartment";
export const get_department = "/department/getAll";
export const post_Deignation = "/designation/saveDesignation";
export const get_attendence = "/attendance/fetch";
// export const post_attendence ='/AttendanceDetails/post'
export const get_leavetype = "/leave/get";
export const Basic_Employee = "/basic/fetchdata";
export const create_leave = "/CreateLeaveRequest/post";
export const post_attendencebyDate = "/attendance/byDate";
export const work_data = "/work/fetchData";
export const get_branch = "/branch/fetchData";
export const post_work = "/work/saveWork";
export const post_bank = "/bank/saveBankingInfo";
export const post_Emergency = "/emergency/saveEmergencyContact";
export const post_branch = "/branch/save";
export const get_leave = "/CreateLeaveRequest/get";
export const get_leaveDetails = "/holiday/leaveDetails";
export const get_jobtitle = "/addJobTitle/getJob";
export const get_shift = "/shiftManagement/viewShift";
export const post_event = "/event/saveData";
export const post_training = "/trainingName/save";
export const shiftManagement_post = "/shiftManagement/addShift";
export const training_master_post = "/employee/save";
export const event_get = "/event/fetchData";
export const trainingName_get = "/trainingName/fetchdata";
export const post_leaveType = "/leave/leaveType";
export const get_employeeTraining = "/employee/get";
export const post_trainingFeedback = "/training/feedback";
export const post_attendance = "/attendance/save";
export const post_OverTime = "/OverTime/save";
export const get_bank = "/bank/getBankInfo";
export const post_addHoliday = "/holiday/leaveDetail";
export const get_emergencyInfo = "/emergency/getAllEmergencyContactInfo";
export const get_salarySlipAll = "/salarySlip/getAll";
export const post_advance_Sal = "/advance/save";
export const get_advance_Sal = "/advance/getAll";
export const get_notification = "/notification/getAll";
export const update_notification = "/notification/update{id}";
export const post_ForgotEmail = "/api/forgot-password/email";
export const resignation = "/resignation/save";
export const resignationDetails = "/resignation/fetch";
export const getSalByID = "/salarySlip/getById";
export const post_Deduction = "/deduction/save";
export const get_Deuction = "/deduction/getAll";
export const get_LeaveRecord = "/record/getAll";
export const post_LeaveRecord = "/record/save";
export const post_WFH = "/WFH/save";
export const get_WFH = "/WFH/getAll";
export const get_trainingFeeback = "/training/getById/{id}";
export const post_Termiantion = "/termination/save";
export const get_feedback = "/training/getAll";
export const get_Termiantion = "/termination/getAll";

export const post_role = "/role/save";
export const get_roles = "/role/getAll"; 
export const update_role = "/role/update/{id}";

export const get_permission_urls = "/permission/urls";
export const post_permission = "/permission/save";
export const put_permission = "/permission/save";
export const delete_permission = "/permission/save";
export const get_permissions = "/permission/urls";

// Role Module Management APIs
export const save_role_modules = "/roleModule/save";
export const get_all_role_modules = "/roleModule/getAll";
export const delete_role_modules = "/roleModule/delete";

export const get_employee_roles = "/employees/roles";
export const post_employee_role = "/employees/{id}/roles";
export const put_employee_roles = "/employees/{id}/roles";
export const delete_employee_role = "/employees/{id}/roles";
